var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-good-table',{ref:"table",attrs:{"columns":_vm.columns,"rows":_vm.clients,"sort-options":{
    enabled: true,
    initialSortBy: {field: 'created_at', type: 'desc'}
  },"pagination-options":{
    enabled: true,
    perPage: 20,
    nextLabel: _vm.$t('pagination.next'),
    prevLabel: _vm.$t('pagination.back'),
    rowsPerPageLabel: _vm.$t('pagination.output'),
    allLabel: _vm.$t('pagination.all'),
    ofLabel: _vm.$t('pagination.of'),
  }},on:{"on-row-click":_vm.onClickClientRow,"on-column-filter":_vm.onColumnFilter},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'options')?_c('span',[_c('router-link',{staticClass:"btn btn-icon",attrs:{"to":{ name: 'clients.client', params: { clientId: props.row.id }}}},[_c('font-awesome-icon',{staticClass:"sidebar__menu-icon",attrs:{"icon":"eye"}})],1)],1):_c('span',[_vm._v(_vm._s(props.formattedRow[props.column.field]))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }